

















	import Vue from 'vue';
	import Component from 'vue-class-component';

/** The prev icon for slide group */
@Component
	export default class PrevIcon extends Vue {}
